import Swiper from 'swiper/bundle';
// import Swiper styles
import 'swiper/swiper-bundle.css';
const sliders = {
    init() {

        function initializeSwiper() {
            // Check if Swiper instance exists and destroy it to avoid duplicates
            if (window.featuresSlider !== undefined) {
                window.featuresSlider.destroy(true, true);
            }

            // Determine the current viewport width
            const screenWidth = window.innerWidth;

            // Default settings for mobile
            let swiperSettings = {
                slidesPerView: 1,
                spaceBetween: 8,
                loop: true,
                loopAdditionalSlides: 0,
            };

            // If the viewport is at least 768 pixels wide, use the fade effect
            if (screenWidth >= 1200) {
                swiperSettings = Object.assign(swiperSettings, {
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    loop: false,
                    spaceBetween: 0,
                    loopAdditionalSlides: 0,
                });
            }

            // Initialize Swiper with the determined settings
            window.featuresSlider = new Swiper('.js-features-slider', swiperSettings);
        }

        // Initial setup
        initializeSwiper();

        // Reinitialize Swiper on window resize with a debounce to improve performance
        let resizeDebounce;
        window.addEventListener('resize', function() {
            clearTimeout(resizeDebounce);
            resizeDebounce = setTimeout(initializeSwiper, 250); // Adjust debounce time as needed
        });


        // $('[data-slide]').on('click', function(e) {
        //     // Prevent the default link navigation initially
        //     e.preventDefault();
        //
        //     var $this = $(this);
        //     var slideIndex = parseInt($this.attr('data-slide'));
        //     var $parent = $this.parent();
        //
        //     // Check if the clicked item's parent already has the 'active' class
        //     if (!$parent.hasClass('active')) {
        //         // It's not active, so we activate it and perform the sliding logic
        //         $('[data-slide]').parent().removeClass('active'); // Remove 'active' from all others
        //         $parent.addClass('active'); // Add 'active' to this item's parent
        //         featuresSlider.slideTo(slideIndex);
        //
        //         // Store that this item has been clicked once to activate it
        //         $this.data('wasClicked', true);
        //     } else if ($parent.hasClass('active') && $this.data('wasClicked')) {
        //         // The item is active and was previously clicked, navigate to the link
        //         window.location.href = $this.attr('href');
        //     }
        // });

        $('[data-slide]').on('mouseenter', function(e) {
            // Prevent the default link navigation initially
            e.preventDefault();

            var $this = $(this);
            var slideIndex = parseInt($this.attr('data-slide'));
            var $parent = $this.parent();

            // Check the event type and existing conditions before acting
            if (e.type === 'mouseenter' && !$parent.hasClass('active')) {
                $('[data-slide]').parent().removeClass('active'); // Remove 'active' from all others
                $parent.addClass('active'); // Add 'active' to this item's parent
                featuresSlider.slideTo(slideIndex);
                $this.data('wasClicked', true);
            } else if (e.type === 'click' && $parent.hasClass('active') && $this.data('wasClicked')) {
                // Navigate to the link only on click and if it's already active and was previously hovered
                window.location.href = $this.attr('href');
            }
        });





        var testimonialSlider = new Swiper('.js-testimonial-slider', {
            spaceBetween: 8,
            slidesPerView: 1, // Adjust based on your design, can use fractional values or 'auto'
            loop: true,
            loopAdditionalSlides: 1,
            navigation: {
                nextEl: '.js-testimonial-slider .next',
                prevEl: '.js-testimonial-slider .prev',
            },
            breakpoints: {
                // When the viewport is below 768 pixels
                768: {
                    slidesPerView: 1, // Use 'auto' for slidesPerView under 768px
                    spaceBetween: 32, // You can adjust the spaceBetween or any other settings specifically for this breakpoint
                    loopAdditionalSlides: 1,
                }
            }
        });

        var footerSlider = new Swiper('.js-footer-slider', {
            spaceBetween: 32,
            slidesPerView: 3, // Adjust based on your design, can use fractional values or 'auto'
            loop: true,
            loopAdditionalSlides: 3,
            autoplay: {
                delay: 1, // Delay between transitions in ms
                disableOnInteraction: false, // Continue autoplay after user interaction
            },
            speed: 6000,
            preloadImages: false,
            lazy: true,
            simulateTouch: false,
            // Define breakpoints
            breakpoints: {
                // When the viewport is below 768 pixels
                768: {
                    slidesPerView: 6, // Use 'auto' for slidesPerView under 768px
                    spaceBetween: 32, // You can adjust the spaceBetween or any other settings specifically for this breakpoint
                    loopAdditionalSlides: 6,
                }
            }
        });

        function updateGradientSlides(swiper) {
            // Remove gradient classes from all slides
            swiper.slides.removeClass('swiper-slide-first swiper-slide-last');

            // Add 'swiper-slide-first' class to the first visible slide
            swiper.slides.eq(swiper.activeIndex).addClass('swiper-slide-first');

            // Calculate the index of the last visible slide
            let lastIndex = swiper.activeIndex + swiper.params.slidesPerView - 1;
            if (lastIndex >= swiper.slides.length) lastIndex = swiper.slides.length - 1; // Adjust if lastIndex exceeds slide count

            // Add 'swiper-slide-last' class to the last visible slide
            swiper.slides.eq(lastIndex).addClass('swiper-slide-last');
        }

    }
}
export {sliders}